export { default as EventManager } from './event-manager';